'use strict';

import util from '../../util';
import search from '../search';
import beautyStationTabs from './beauty-station-tabs';
import { global as modal } from '../../modal';
import minicart from '../../minicart';
import product from '../product';
import page from '../../page';
import progress from '../../progress';

var userLocale = User.locale.replace('_', '-');

var showFilters = function () {
    $('.filters-btn').on('click', function () {
        $('.filters-container').show(200);
        $('#beauty-station-tabs').hide();

        document.body.style.overflow = 'hidden';
    });
};

var hideFilters = function () {
    $('.back-to-orders-btn, .cancel-filter').on('click', function (e) {
        e.preventDefault();

        $('.filters-container').hide(200);
        $('#beauty-station-tabs').show();

        document.body.style.overflow = 'auto';
    });
}

var orderHistoryAddToCart = function() {
	$('.search-result-content').on('click', '.order-history-add-to-cart', function(event) {
        event.preventDefault();
		var pid = $(this).data('pid');		
		minicart.addProduct({ pid: pid });	
	});
}

var viewOrderDetail = function () {
    $(document).on('click', 'form[id$="dwfrm_orders"] button.view-details', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var orderId = $(this).data('order-id');
        var url = util.appendParamsToUrl(Urls.GetOrderDetailsByOrderId, {
            orderNo: orderId
        });
        window.location.href = url;
    });
}

var onSortByFilterChange = function() {
	$('#sortByFilter').on('change', function(e) {
		var selectedSortByvalue = $(this).val();
		console.log(selectedSortByvalue);
		var url = util.appendParamsToUrl(Urls.GetOrderHistoryBasedOnSortByFilter,{
			selectedSortByvalue: selectedSortByvalue,
    		format: 'ajax'
    	});
		$.ajax({
            url: url,
            success: function (response) {
            	$('.search-result-content.order-history-list').find('.order-history-results.accordion').html(response);
            	Foundation.reInit($(".accordion"));
            }
        });
	});
}

$(window).on('changed.zf.mediaquery', function () {

    if (Foundation.MediaQuery.is('medium')) {
        $('.filters-container').show();
    } else {
        $('.filters-container').hide();
    }
});

var selectFilter = function () {
    var $filtersDetailsContainer = $('.filters-details-container');

    $filtersDetailsContainer.on('click', '.filter-months-label', function (e) {
        // uncheck input and remove checked label class
        $filtersDetailsContainer.find('[checked=checked]').removeAttr('checked');
        $filtersDetailsContainer.find('.label-checked').removeClass('label-checked');

        // check input and add checked label class
        $(e.target).parent().find('input[name="months"]').attr('checked', 'checked');
        $(e.target).addClass('label-checked');
    });
}

var enableFilterButton = function () {
    var $submitFilterBtn = $('.submit-filter-btn');

    $('.filter-months-select').on('change', function () {
        $submitFilterBtn.removeAttr('disabled');
    });

    $('.includeSamplesCheckbox').on('click', 'input[name="includeSamples"]', function () {
        $submitFilterBtn.removeAttr('disabled');
    })

    $('.filter-months-wrapper').on('click', function () {
        $submitFilterBtn.removeAttr('disabled');
    })
}

var clearFilter = function () {
    $('.clear-filter, .show-selected-filter').on('click', function () {
        $('.filter-months-select, .months-input').val('period');

        $('input[name="includeSamples"]').prop('checked', false);

        $('.submit-filter-btn').trigger('click');
    });
}

var setMonthsValue = function () {
    var url = window.location.href;
    var queryString = util.getQueryString(url);
    var queryStringParams = util.getQueryStringParams(queryString);

    if (queryStringParams.months) {
        $('.filter-months-select').val(queryStringParams.months);

        //for mobile
        var $monthWrapper = $('.filter-months-wrapper input[value="' + queryStringParams.months + '"]');

        $monthWrapper.attr('checked', true);
        $monthWrapper.siblings().addClass('label-checked');

        if (queryStringParams.months !== 'period') {
            $('.show-selected-filter, .showing-result').removeClass('hide');
            $('.selected-filter-value').text(queryStringParams.months);
        }
    }

    if (queryStringParams.includeSamples) {
        $('input[name="includeSamples"]').prop('checked', true);
    }
};

var selectMonth = function () {
    $('.filter-months-input').on('change', function () {
        $('.months-input').val($(this).val());
    });
};

var replenishmentUpdate = function () {
    var popup = require('../../modal').create('#updated-replenishment', '.modal-body', {});

    $('#replenishments').on('click', '.replenishmentupdate', function (e) {
        e.preventDefault();
        var href = $(this).attr('href');
        var uuid = getQueryValue('rid', href);
        popup.open();

        $('#updated-replenishment')
            .data('href', href)
            .data('uuid', uuid);
    });

    $(document).on('click', '#updated-replenishment .modal-btn-confirm', function () {
        var href = $('#updated-replenishment').data('href');
        var uuid = $('#updated-replenishment').data('uuid');

        var rdays = $('.' + uuid.substring(0, 26) + '_days').val();
        var replenishmentQuantity = $('.' + uuid.substring(0, 26) + '_quantity').val();
        var updateReplenishment = href + '&rdays=' + rdays + '&qty=' + replenishmentQuantity + '&format=ajax';

        $.ajax({
            url: updateReplenishment,
            method: 'GET',
            error: function (data) {
                page.redirectOnAjaxError(data);
            }
        }).done(function (data) {
            popup.close();

            var replenishmentListItem = $('.' + uuid + '_rid');

            //update nextdate data attribute on freeze/unfreeze buttons after replenishment update so they can be properly displayed in the dialogs
            replenishmentListItem.find('.replenishmentfreeze').data('nextdate', data.rawDate);
            replenishmentListItem.find('.replenishmentunfreeze').data('nextdate', data.rawDate);

            var headerDate = $(replenishmentListItem).find('.order-history-header .order-status .value');
            var headerPrice = $(replenishmentListItem).find('.order-history-header .price-sales-replenishment .value');
            var mobilePrice = $(replenishmentListItem).find('.order-history-items .mobile-price-replenishment .price-sales');

            headerDate.html(data.nextScheduledDate);
            headerPrice.html(data.formattedPrice);
            mobilePrice.html(data.formattedPrice);
        });
    });

}

var replenishmentFreeze = function () {
    var popup = require('../../modal').create('#freeze-replenishment', '.modal-body', {});

    $('#replenishments').on('click', '.replenishmentfreeze', function (e) {
        e.preventDefault();
        var href = $(this).attr('href');
        var uuid = getQueryValue('rid', href);

        var nextScheduledDate = new Date($(this).data('nextdate'));

        popup.open();
        var freezeMonth = $('.freezeperioddropdown').val();
        var nextCalculatedDate = new Date(nextScheduledDate.getFullYear(), nextScheduledDate.getMonth() + parseInt(freezeMonth, 10), nextScheduledDate.getDate());

        $('#freeze-replenishment .next-replenishment').html(nextCalculatedDate.toLocaleDateString(userLocale));
        $('#freeze-replenishment')
            .data('nextDate', nextScheduledDate)
            .data('href', href)
            .data('uuid', uuid);
    });

    $(document).on('change', '#freeze-replenishment .freezeperioddropdown', function (e) {
        e.preventDefault();
        var nextDate = new Date($('#freeze-replenishment').data('nextDate'));
        var selectedVal = $(e.currentTarget).val();

        var date = new Date(nextDate);
        date.setMonth(nextDate.getMonth() + parseInt(selectedVal, 10));

        $('#freeze-replenishment .next-replenishment').html(date.toLocaleDateString(userLocale));
    });

    $(document).on('click', '#freeze-replenishment .modal-btn-confirm', function() {
        handleFreezeUnfreezeConfirmation(popup, '#freeze-replenishment', true)
    });

}

var replenishmentUnfreeze = function () {
    var popup = require('../../modal').create('#unfreeze-replenishment', '.modal-body', {});

    $('#replenishments').on('click', '.replenishmentunfreeze', function (e) {
        e.preventDefault();
        var href = $(this).attr('href');
        var uuid = getQueryValue('rid', href);

        var nextScheduledDate = new Date($(this).data('nextdate'));

        var today = new Date();

        if (today.getDate() < nextScheduledDate.getDate()) {
            nextScheduledDate.setMonth(today.getMonth());
        } else {
            nextScheduledDate.setMonth(today.getMonth() + 1);
        }

        popup.open();

        $('#unfreeze-replenishment .next-replenishment').html(nextScheduledDate.toLocaleDateString(userLocale));
        $('#unfreeze-replenishment')
            .data('nextDate', nextScheduledDate)
            .data('href', href)
            .data('uuid', uuid);
    });

    $(document).on('click', '#unfreeze-replenishment .modal-btn-confirm', function() {
        handleFreezeUnfreezeConfirmation(popup, '#unfreeze-replenishment', false)
    });
}

function handleFreezeUnfreezeConfirmation(popup, popupId, freezeReplenishment) {
    var href = $(popupId).data('href');
    var uuid = $(popupId).data('uuid');

    var freezeReplenishmentUrl = util.appendParamToURL(href, 'freeze', freezeReplenishment.toString())

    //add freeze period if this is a freeze replenishment request
    if (freezeReplenishment) {
        var frperiod = $('.freezeperioddropdown').val();
        freezeReplenishmentUrl = util.appendParamToURL(freezeReplenishmentUrl, 'frperiod', frperiod);
    }

    freezeReplenishmentUrl = util.appendParamToURL(freezeReplenishmentUrl, 'format', 'ajax');

    $.ajax({
        url: freezeReplenishmentUrl,
        method: 'GET',
        error: function (data) {
            page.redirectOnAjaxError(data);
        }
    }).done(function (data) {
        var replenishmentListItem = $('.' + uuid + '_rid');

        if (data.success) {
            $(replenishmentListItem).find('.freeze-unfreeze-toggle').toggleClass('show hide');
        }

        popup.close();
        var headerDate = $(replenishmentListItem).find('.order-history-header .order-status .value');
        headerDate.html(data.nextScheduledDate);
    });
}

function getQueryValue(str, href) {
    var queryString = href

    //get query parameters from url
    var query = queryString.split('?');

    if (query.length > 1) {

        var queryParams = query[1].split('&');

        //loop through query parameters
        for (var i = 0; i < queryParams.length; i++) {

            //get parameter key and parameter value
            var kvp = queryParams[i].split('=');

            if (kvp.length > 1) {
                var key = kvp[0];
                var val = kvp[1];

                if (key == str) {
                    return val;
                }
            }
        }
    }
    return null;
}

var replenishmentCancel = function () {
    $('#replenishments').on('click', '.replenishmentcancel', function (e) {
        e.preventDefault();
        var href = $(this).attr('href');
        var popup = require('../../modal').create('#cancel-replenishment', '.modal-body', {});
        popup.open();

        $('#cancel-replenishment').data('href', href);
    });

    $(document).on('click', '#cancel-replenishment .modal-btn-confirm', function () {
        var href = $('#cancel-replenishment').data('href');
        window.location = href;
    });
}

var ratingsReviewsInit = function () {
    $('.search-result-content').on('click', '.js-bv-white-review', function (e) {
        e.preventDefault();
        if (typeof ($BV) !== 'undefined') {
            $BV.ui('rr', 'submit_review', { // eslint-disable-line no-undef
                productId: $(this).data('bv-product-id')
            });
        }
    });
}

var downAccordionClick = function () {
    //To hide the default item details from user which were shown before ajax call inside the closed accordion
    $('.order-history-header.accordion-title').on('click', function(event) {
        $(event.target).next('.order-history-items.accordion-content').hide();
    });
	$('.order-history-results.accordion').on('down.zf.accordion', function(e , element) {
	    	var orderNo = $(element).prev('.accordion-title').data('orderno');
	    	var includeSampleFilterCheck = $('#includeSampleFilterCheck').val();
	    	if(!$(element).prev('.accordion-title').data('fetched')) {
	        	var url = util.appendParamsToUrl(Urls.GetOmsOrderDetails,{
	        		orderNo: orderNo,
	        		includeSampleFilterCheck: includeSampleFilterCheck,
	        		format: 'ajax'
	        	});
                progress.show($('.order-history-items .accordion-content'));
	        	$.ajax({
	                url: url,
	                success: function (response) {
                        $(element).show();
	                	$(element).find('.selected-order-detail-content').html(response);
	                	$(element).prev('.accordion-title').data('fetched', true);
	                },
                    complete: function(){
                        progress.hide();
                    }
	            });
	    	}    
            else {
                $(element).show();
            }		    	
	    });
}

/**
 * @function
 * @description Binds the events of the order and replenishments page
 */

function initializeEvents() {
    search.viewMore();
    beautyStationTabs.init();
    ordersAndReplenishments.quickView();
    showFilters();
    hideFilters();
    selectFilter();
    enableFilterButton();
    clearFilter();
    setMonthsValue();
    replenishmentUpdate();
    replenishmentCancel();
    replenishmentFreeze();
    replenishmentUnfreeze();
    selectMonth();
    ratingsReviewsInit();
    downAccordionClick();
    viewOrderDetail();
    orderHistoryAddToCart();
    onSortByFilterChange();
}

var ordersAndReplenishments = {
    init: function () {
        initializeEvents();
    },
    quickView: function () {
        $('.search-result-content').on('click', '.buy-again:not(.full-size-sku)', function (e) {
            e.preventDefault();

            var url = $(this).attr('href');
            $.ajax({
                url: url,
                success: function (response) {
                    modal.setContent($(response).filter('#pdpMain'));
                    modal.addCustomClass('edit-modal quickview-modal');
                    product.initializeEvents();

                    modal.renderContent(response);
                }
            });

        });
    }
};

export default ordersAndReplenishments;
